import React from "react";
import know_rights_banner from "../assets/images/know_rights_banner.png";

const Article = () => {
    return (
        <div className="Article">
                  {/* Section start here */}
        <div className="sub_level_banner">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-4  offset-md-1">
                <div className="about__banner-text">
                  <h1 className="block__title">Know Your Rights</h1>
                  <h5>
                  awareness of violations against women and children
                  </h5>
                </div>
              </div>
              <div className="col-md-6 offset-md-1 about__banner-img pr-md-0">
                <div className=" sub_pages_banner">
                  <img
                    src={know_rights_banner}
                    alt="About Banner"
                    className="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
         {/* Section End here */}
             <div className='container pt-5 pb-5'>
      <div className="row ">
                    <div className="col-sm-12 ">
            <ul className="list_m14 list_m14_sup2">
                <li>
                        <h3>Article 1</h3>
                        <p>All human beings are born free and equal in dignity and rights.They are endowed with reason and conscience and should act towards one another in a spirit of brotherhood.
</p>
                </li>
                <li>
                        <h3>Article 2</h3>
                        <p>Everyone is entitled to all the rights and freedoms set forth in this Declaration, without distinction of any kind, such as race, colour, sex, language, religion, political or other opinion, national or social origin, property, birth or other status. Furthermore, no distinction shall be made on the basis of the political, jurisdictional or international status of the country or territory to which a person belongs, whether it be independent, trust, non-self-governing or under any other limitation of sovereignty.</p>
                </li>
                <li>
                        <h3>Article 3</h3>
                        <p>Everyone has the right to life, liberty and security of person.</p>
                </li>
                <li>
                        <h3>Article 4</h3>
                        <p>No one shall be held in slavery or servitude; slavery and the slave trade shall be prohibited in all their forms.</p>
                </li>
                <li>
                        <h3>Article 5</h3>
                        <p>No one shall be subjected to torture or to cruel, inhuman or degrading treatment or punishment.</p>
                </li>
                <li>
                        <h3>Article 6</h3>
                        <p>Everyone has the right to recognition everywhere as a person before the law.</p>
                </li>
                <li>
                        <h3>Article 7</h3>
                        <p>All are equal before the law and are entitled without any discrimination to equal protection of the law. All are entitled to equal protection against any discrimination in violation of this Declaration and against any incitement to such discrimination.</p>
                </li>
                <li>
                        <h3>Article 8</h3>
                        <p>Everyone has the right to an effective remedy by the competent national tribunals for acts violating the fundamental rights granted him by the constitution or by law.</p>
                </li>
                <li>
                        <h3>Article 9</h3>
                        <p>No one shall be subjected to arbitrary arrest, detention or exile.</p>
                </li>
                <li>
                        <h3>Article 10</h3>
                        <p>Everyone is entitled in full equality to a fair and public hearing by an independent and impartial tribunal, in the determination of his rights and obligations and of any criminal charge against him.</p>
                </li>
                <li>
                        <h3>Article 11</h3>
                        <p>Everyone charged with a penal offence has the right to be presumed innocent until proved guilty according to law in a public trial at which he has had all the guarantees necessary for his defence.</p>
                        <p className="pt-2">Everyone charged with a penal offence has the right to be presumed innocent until proved guilty according to law in a public trial at which he has had all the guarantees necessary for his defence.</p>
                </li>
                <li>
                        <h3>Article 12</h3>
                        <p>No one shall be subjected to arbitrary interference with his privacy, family, home or correspondence, nor to attacks upon his honour and reputation. Everyone has the right to the protection of the law against such interference or attacks.</p>
                </li>
                <li>
                        <h3>Article 13</h3>
                        <p>Everyone has the right to freedom of movement and residence within the borders of each state.</p>
                        <p className="pt-2">Everyone has the right to leave any country, including his own, and to return to his country.</p>
                </li>
                <li>
                        <h3>Article 14.</h3>
                        <p>Everyone has the right to seek and to enjoy in other countries asylum from persecution.
This right may not be invoked in the case of prosecutions genuinely arising from non-political crimes or from acts contrary to the purposes and principles of the United Nations.</p>
                </li>
                <li>
                        <h3>Article 15</h3>
                        <p>Everyone has the right to a nationality
No one shall be arbitrarily deprived of his nationality nor denied the right to change his nationality</p>
                </li>
                <li>
                        <h3>Article 16</h3>
                        <p>Men and women of full age, without any limitation due to race, nationality or religion, have the right to marry and to found a family. They are entitled to equal rights as to marriage, during marriage and at its dissolution.</p>
                        <p className="pt-2">Marriage shall be entered into only with the free and full consent of the intending spouses.</p>
                        <p className="pt-2">The family is the natural and fundamental group unit of society and is entitled to protection by society and the State.</p>
                </li>
                <li>
                        <h3>Article 17</h3>
                        <p>Everyone has the right to own property alone as well as in association with others.</p>
                        <p className="pt-2">No one shall be arbitrarily deprived of his property.</p>
                </li>
                <li>
                        <h3>Article 18</h3>
                        <p>Everyone has the right to freedom of thought, conscience and religion; this right includes freedom to change his religion or belief, and freedom, either alone or in community with others and in public or private, to manifest his religion or belief in teaching, practice, worship and observance.</p>
                </li>
                <li>
                        <h3>Article 19</h3>
                        <p>Everyone has the right to freedom of opinion and expression; this right includes freedom to hold opinions without interference and to seek, receive and impart information and ideas through any media and regardless of frontiers.</p>
                </li>
                <li>
                        <h3>Article 20</h3>
                        <p>Everyone has the right to freedom of peaceful assembly and association.</p>
                        <p className="pt-2">No one may be compelled to belong to an association.</p>
                </li>
                <li>
                        <h3>Article 21</h3>
                        <p>Everyone has the right to take part in the government of his country, directly or through freely chosen representatives.</p>
                        <p className="pt-2">Everyone has the right of equal access to public service in his country.</p>
                        <p className="pt-2">The will of the people shall be the basis of the authority of government; this will shall be expressed in periodic and genuine elections which shall be by universal and equal suffrage and shall be held by secret vote or by equivalent free voting procedures.</p>
                </li>
                <li>
                        <h3>Article 22</h3>
                        <p>Everyone, as a member of society, has the right to social security and is entitled to realization, through national effort and international co-operation and in accordance with the organization and resources of each State, of the economic, social and cultural rights indispensable for his dignity and the free development of his personality.</p>
                </li>
                <li>
                        <h3>Article 23</h3>
                        <p>Everyone has the right to work, to free choice of employment, to just and favourable conditions of work and to protection against unemployment.
Everyone, without any discrimination, has the right to equal pay for equal work.</p>
<p className="pt-2">Everyone who works has the right to just and favourable remuneration ensuring for himself and his family an existence worthy of human dignity, and supplemented, if necessary, by other means of social protection.</p>
<p className="pt-2">Everyone has the right to form and to join trade unions for the protection of his interests.</p>
                </li>
                <li>
                        <h3>Article 24</h3>
                        <p>Everyone has the right to rest and leisure, including reasonable limitation of working hours and periodic holidays with pay.</p>
                </li>
                <li>
                        <h3>Article 25</h3>
                        <p>Everyone has the right to a standard of living adequate for the health and well-being of himself and of his family, including food, clothing, housing and medical care and necessary social services, and the right to security in the event of unemployment, sickness, disability, widowhood, old age or other lack of livelihood in circumstances beyond his control.</p>
                        <p className="pt-2">Motherhood and childhood are entitled to special care and assistance. All children, whether born in or out of wedlock, shall enjoy the same social protection.</p>
                </li>
                <li>
                        <h3>Article 26</h3>
                        <p>Everyone has the right to education. Education shall be free, at least in the elementary and fundamental stages. Elementary education shall be compulsory. Technical and professional education shall be made generally available and higher education shall be equally accessible to all on the basis of merit.</p>
                        <p className="pt-2">Education shall be directed to the full development of the human personality and to the strengthening of respect for human rights and fundamental freedoms. It shall promote understanding, tolerance and friendship among all nations, racial or religious groups, and shall further the activities of the United Nations for the maintenance of peace.</p>
                        <p className="pt-2">Parents have a prior right to choose the kind of education that shall be given to their children.</p>
                </li>
                <li>
                        <h3>Article 27</h3>
                        <p>Everyone has the right freely to participate in the cultural life of the community, to enjoy the arts and to share in scientific advancement and its benefits.</p>
                        <p className="pt-2">Everyone has the right to the protection of the moral and material interests resulting from any scientific, literary or artistic production of which he is the author.</p>
                </li>
                <li>
                        <h3>Article 28</h3>
                        <p>Everyone is entitled to a social and international order in which the rights and freedoms set forth in this Declaration can be fully realized.</p>
                </li>
                <li>
                        <h3>Article 29</h3>
                        <p>Everyone has duties to the community in which alone the free and full development of his personality is possible.</p>
                <p className="pt-2">In the exercise of his rights and freedoms, everyone shall be subject only to such limitations as are determined by law solely for the purpose of securing due recognition and respect for the rights and freedoms of others and of meeting the just requirements of morality, public order and the general welfare in a democratic society.</p>
                </li>
              
            </ul>
            <h3>These rights and freedoms may in no case be exercised contrary to the purposes and principles of the United Nations.

</h3>
            </div>
            </div>
            </div>
        </div>
    )
};

export default Article;
 